import React from 'react';
import PropTypes from 'prop-types';
import graphql from "graphql";

import Helmet from 'react-helmet';
import Link from "gatsby-link";
import { Link as ScrollLink } from 'react-scroll';
import { Switch, matchPath, withRouter } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import './all.sass';
import './animations.css';
import logo from '../img/logo.svg';
import { scroller, animateScroll } from 'react-scroll';

class TransitionHandler extends React.Component {

  shouldComponentUpdate(nextProps) {
    return this.props.location.pathname === window.location.pathname;
  }

  componentWillUpdate(nextProps) {
    const { location } = nextProps;
    const { scrollTo, scrollOffset = 0 } = location.state ? location.state : { scrollTo: false, scrollOffset: 0 };
    if (scrollTo) {
      scroller.scrollTo(scrollTo, {
        offset: scrollOffset,
        smooth: false,
      });
    }
  }

  render() {
    const { children } = this.props;
    return (
      <div className="transition-container">
        {children}
      </div>
    );
  }
}

let lastScrollTop = 0;
function getTransition(location) {
  const { state } = location;
  let transitionClass = state && state.transition ? state.transition : 'pages-up';
  return transitionClass;
}

const Logo = ({ title = '' }) => (<img className="main-logo" src={logo} alt={title}/>)

const ConditionalLogoLink = withRouter(({ title, location: { pathname } }) => (
  <div className="bottom-left is-unselectable">
    { !matchPath(pathname, { path: '/projects/:slug', isExact: true }) ?
      (
        matchPath(pathname, { path: '/' }) ?
          <ScrollLink to="/" href="/" smooth={true}>
            <Logo title={title} />
          </ScrollLink>
        : <Link to="/">
          <Logo title={title} />
        </Link>
      ) : null }
  </div>
))

const TemplateWrapper = ({
  children,
  location,
  location: { state, action },
  data: { front: { frontmatter: { title } } }
}) => (
  <div>
    <Helmet title={title}>
      <meta name="apple-mobile-web-app-title" content={title} />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black" />
      <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon" />
      <link rel="icon" href="/favicon.ico" type="image/x-icon" />
      <link rel="icon" type="image/png" href="/favicon-16x16.png" sizes="16x16" />  
      <link rel="icon" type="image/png" href="/favicon-32x32.png" sizes="32x32" />
      <link rel="apple-touch-icon" href="/apple-touch-iphone.png" />
      <link rel='mask-icon' href='/safari-pinned-tab.svg' />
    </Helmet>
    <ConditionalLogoLink title={title} />
    <TransitionGroup
      childFactory={(child) => React.cloneElement(
        child,
        { classNames: getTransition(location) }
      )}
    >
      <CSSTransition
        key={location.key}
        classNames={getTransition(location)}
        timeout={500}
        onExit={(node) => {
          const scrollY = window.scrollY;

          if (scrollY > 0) {
            lastScrollTop = scrollY;
          }
        }}
        onExiting={(node) => {
          if (lastScrollTop > 0) {
            node.scrollTop = lastScrollTop;
          }
          lastScrollTop = 0;
        }}
      >
        <TransitionHandler location={location}>
          <Switch location={location}>
            {children()}
          </Switch>
        </TransitionHandler>
      </CSSTransition>
    </TransitionGroup>
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object
};

export default TemplateWrapper;

export const mainQuery = graphql`
  query MainQuery {
    front: markdownRemark(frontmatter: { path: { eq: "/" } }) {
      frontmatter {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js